var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-anchor",
    style: _vm.styles
  }, [_c('div', {
    staticClass: "tag-line",
    style: _vm.lineStyle
  }), _vm.tailPosition !== 'none' ? _c('div', {
    staticClass: "tag-dot",
    style: {
      backgroundColor: _vm.tailColourEffective
    }
  }) : _vm._e(), _c('div', {
    ref: "el",
    staticClass: "tag-action",
    class: ["tag-action--".concat(_vm.type), {
      'tag-action--pulse': _vm.shouldPulse
    }],
    style: _vm.labelStyle,
    on: {
      "click": _vm.triggerAction
    }
  }, [_c('fa', {
    attrs: {
      "icon": _vm.icon,
      "fixed-width": ""
    }
  }), _c('div', {
    staticClass: "tag-action__ring"
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }